<section class="centered-with-padding pb-9 pt-4">
  <ul class="mb-5 flex select-none flex-col gap-x-5 desk:flex-row">
    <li class="flex cursor-pointer items-center gap-x-1">
      <input
        (input)="onShowOpenStoresChange($event)"
        [checked]="showOpenStores()"
        class="size-6 cursor-pointer"
        id="openStores"
        type="checkbox" />
      <label class="flex cursor-pointer flex-row items-center gap-x-1" for="openStores">
        <app-svg [height]="37" src="assets/icons/pin-map-green.svg" />
        <span>{{ "COMPONENT.CARTE-OPPORTUNITES.STORES_OPEN" | translate }}</span>
      </label>
    </li>
    <li class="flex cursor-pointer items-center gap-x-1">
      <input
        (input)="onShowOpeningOpportunitiesChange($event)"
        [checked]="showOpeningOpportunities()"
        class="size-6 cursor-pointer"
        id="openingOpportunities"
        type="checkbox" />
      <label class="flex cursor-pointer flex-row items-center gap-x-1" for="openingOpportunities">
        <app-svg [height]="37" src="assets/icons/pin-map-purple.svg" />
        <span>{{ "COMPONENT.CARTE-OPPORTUNITES.OPENING_OPPORTUNITIES" | translate }}</span>
      </label>
    </li>
  </ul>
  <div class="rounded-3xl bg-gray-light p-5">
    <app-map [config]="opportunitiesConfig()" />
  </div>
  @if (opportunitiesOverseas().length > 0) {
    <h2 class="title-h2 mb-5 mt-11 desk:mt-7">
      {{ "COMPONENT.CARTE-OPPORTUNITES.OVERSEAS_OPPORTUNITIES" | translate }}
    </h2>
    <div class="grid grid-cols-1 gap-4 desk:grid-cols-3">
      @for (opportunity of opportunitiesOverseas(); track $index) {
        <div class="flex w-full flex-col items-center justify-center gap-y-4 rounded-3xl bg-gray-light px-6 py-5">
          <div class="text-center font-title text-[22px]">{{ opportunity }}</div>
          <div class="text-center text-[14px]">
            {{ "COMPONENT.MAP-POPIN.WANT_TO_KNOW_MORE_OPPORTUNITY" | translate }}
          </div>
          @if (data.contactUrl; as url) {
            <app-button [label]="'GLOBAL.CONTACT_US' | translate" [url]="url" />
          }
        </div>
      }
    </div>
  }
</section>
